export const GET_FILL_PROVIDERS_REQUEST = 'GET_FILL_PROVIDERS_REQUEST';
export const GET_FILL_PROVIDERS_SUCCESS = 'GET_FILL_PROVIDERS_SUCCESS';
export const GET_FILL_PROVIDERS_FAILURE = 'GET_FILL_PROVIDERS_FAILURE';

export const getFillProviders = () => ({
  type: GET_FILL_PROVIDERS_REQUEST,
});

export const getFillProvidersSuccess = (fillProviders) => ({
  type: GET_FILL_PROVIDERS_SUCCESS,
  fillProviders,
});

export const getFillProvidersFailure = (error) => ({
  type: GET_FILL_PROVIDERS_FAILURE,
  error,
});
